import axiosInstance from '../../../services/axios/axios';
import msalInstance from '../../../services/msal/msal';
import { WrapImsPacket } from '../../../store/utility';
import { UAR_CONSTANTS } from './constants';
import { KEY_SESSION } from '../../../components/Navigation/AppBar/ImpersonationIcon/_constants';
import * as actions from '../../../store/uar/actions';
import msalConfig from 'services/msal/config';
import { acquireAccessToken } from 'services/msal/_utilities';

export const checkPermissions = (
	profile,
	loggedInEsoFiId,
	bulkSelections,
	allowAccountAdmin = false
) => {
	if (bulkSelections && bulkSelections.length > 0) {
		// bulk flow
		let valid = true;
		bulkSelections.forEach(profile => {
			//TODO:  can probably streamline with something other than 'foreach'
			//assumption:  only three groups can perform actions:  supervisors, account administrators (non-employees only), and delegated owners
			const supervisor = profile.supervisorEsoFiIds
				? profile.supervisorEsoFiIds.includes(loggedInEsoFiId)
				: false;
			const delegatedOwner =
				profile.isDelegated && profile.delegatedOwnerEsoFiId
					? profile.isDelegated &&
					  profile.delegatedOwnerEsoFiId === loggedInEsoFiId
					: false;
			if (allowAccountAdmin) {
				const accountAdmin =
					profile.accountAdminEsoFiId &&
					profile.type === 'nonEmployee'
						? profile.accountAdminEsoFiId === loggedInEsoFiId
						: false;
				valid = valid && (supervisor || delegatedOwner || accountAdmin);
			} else {
				valid = valid && (supervisor || delegatedOwner);
			}
		});
		return valid;
	} else if (profile && loggedInEsoFiId) {
		//single flow
		//assumption:  only three groups can perform actions:  supervisors, account administrators (non-employees only), and delegated owners
		const supervisor = profile.supervisorEsoFiIds
			? profile.supervisorEsoFiIds.includes(loggedInEsoFiId)
			: false;
		const delegatedOwner =
			profile.isDelegated && profile.delegatedOwnerEsoFiId
				? profile.isDelegated &&
				  profile.delegatedOwnerEsoFiId === loggedInEsoFiId
				: false;
		if (allowAccountAdmin) {
			const accountAdmin =
				profile.accountAdminEsoFiId && profile.type === 'nonEmployee'
					? profile.accountAdminEsoFiId === loggedInEsoFiId
					: false;
			return supervisor || delegatedOwner || accountAdmin;
		} else {
			return supervisor || delegatedOwner;
		}
	} else if (profile && Object.keys(profile).length > 0) {
		//single flow (alternative)
		let valid = true;
		Object.keys(profile).forEach(key => {
			//TODO:  can probably streamline with something other than 'foreach'; WHERE DOES THIS COME INTO PLAY?
			//assumption:  only three groups can perform actions:  supervisors, account administrators (non-employees only), and delegated owners
			const supervisor = profile[key].details.supervisorEsoFiIds
				? profile[key].details.supervisorEsoFiIds.includes(
						loggedInEsoFiId
				  )
				: false;
			const delegatedOwner =
				profile[key].details.isDelegated &&
				profile[key].details.delegatedOwnerEsoFiId
					? profile[key].details.isDelegated &&
					  profile[key].details.delegatedOwnerEsoFiId ===
							loggedInEsoFiId
					: false;
			if (allowAccountAdmin) {
				const accountAdmin =
					profile[key].details &&
					profile[key].details.accountAdminEsoFiId &&
					profile[key].details.type === 'nonEmployee'
						? profile.accountAdminEsoFiId === loggedInEsoFiId
						: false;
				valid = valid && (supervisor || delegatedOwner || accountAdmin);
			} else {
				valid = valid && (supervisor || delegatedOwner);
			}
		});
		return valid;
	} else {
		return false;
	}
};

export const checkForUsersFound = (queryParams, bulkSelections) => {
	return (
		queryParams.has('esoFiId') ||
		(bulkSelections && bulkSelections.length > 0)
	);
};

export const checkForEsoFiIdNumber = queryParams => {
	let isNum = false;
	if (queryParams.has('esoFiId')) {
		const parsed = parseInt(queryParams.get('esoFiId'), 10);
		isNum = !isNaN(parsed);
	}
	return isNum;
};

export const checkForBulkFlow = queryParams => {
	if (queryParams && queryParams.has('esoFiId')) {
		return false;
	} else {
		return true;
	}
};

export const checkForImpersonation = async dispatch => {
	let fEsoId = await fetchSessionVariable('ImpersonatorFESO');
	fEsoId = fEsoId ?? sessionStorage.getItem(KEY_SESSION);
	if (fEsoId) {
		axiosInstance
			.get('/api/UserAccessReview/GetImpersonator/' + fEsoId)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const data = response.data;
							const responseCode = response.data.responseCode;
							switch (responseCode) {
								case 200:
									dispatch(actions.setImpersonator(data));
									break;
								default:
									break;
							}
						}
						break;

					default:
						break;
				}
			});

		return fEsoId;
	}
};
export const fetchSessionVariable = async key => {
	let sessionVar = null;
	try {
		const token = await acquireAccessToken(msalConfig.requests.api);
		const response = await fetch('../Session/GetSessionValue/', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ key: key }),
		});
		sessionVar = await response.json();
	} catch (error) {
		return sessionVar;
	}
	return sessionVar;
};

export const queryGetUserStaffByUpn = async (
	loggedInUser,
	onQuery,
	onResponse,
	onSuccess,
	onFailure,
	onError,
	onComplete,
	dispatch
) => {
	const impersonator = await checkForImpersonation(dispatch);
	onQuery();
	if (loggedInUser?.username || impersonator) {
		const upn = loggedInUser?.username;

		postApi(
			'/api/UserAccessReview/GetUserInfo/Staff',
			WrapImsPacket({ upn: upn, impersonationId: impersonator }),
			onResponse,
			onSuccess,
			onFailure,
			onError
		);
	} else {
		let messages = [];
		if (!msalInstance.getActiveAccount()) {
			messages.push({
				Key: 3,
				Value: 'You are not currently logged in.  Please log in and try again.',
			});
		}
		onFailure(messages);
	}
	onComplete();
};

export const queryGetUserProfileByUpn = async (
	loggedInUser,
	onQuery,
	onResponse,
	onSuccess,
	onFailure,
	onError,
	onComplete,
	dispatch
) => {
	const impersonator = await checkForImpersonation(dispatch);
	onQuery();
	if (loggedInUser?.username || impersonator) {
		const upn = loggedInUser?.username;

		postApi(
			'/api/UserAccessReview/GetUserInfo/UserProfile',
			WrapImsPacket({ upn: upn, impersonationId: impersonator }),
			onResponse,
			onSuccess,
			onFailure,
			onError
		);
	} else {
		let messages = [];
		if (!msalInstance.getActiveAccount()) {
			messages.push({
				Key: 3,
				Value: 'You are not currently logged in.  Please log in and try again.',
			});
		}
		onFailure(messages);
	}
	onComplete();
};

export const queryGetOrgChartByEsoFiId = (
	queryParams,
	onQuery,
	onResponse,
	onSuccess,
	onFailure,
	onError,
	onComplete
) => {
	onQuery();
	if (queryParams.has('esoFiId')) {
		getApi(
			'/api/UserAccessReview/GetOrgChart/' + queryParams.get('esoFiId'),
			onResponse,
			onSuccess,
			onFailure,
			onError,
			onComplete
		);
	}
	onComplete();
};

export const queryGetUserInfoByEsoFiId = (
	queryParams,
	onQuery,
	onResponse,
	onSuccess,
	onFailure,
	onError,
	onComplete
) => {
	onQuery();
	if (queryParams.has('esoFiId')) {
		getApi(
			'/api/UserAccessReview/GetUserInfo/' + queryParams.get('esoFiId'),
			onResponse,
			onSuccess,
			onFailure,
			onError,
			onComplete
		);
	}
	onComplete();
};

const getApi = (uri, onResponse, onSuccess, onFailure, onError) => {
	axiosInstance
		.get(uri)
		.then(response => {
			switch (response.status) {
				case 200:
					if (response.data.responseCode) {
						const responseCode = response.data.responseCode;
						let data = onResponse(response.data.payload);
						const messages = response.data.messages;
						switch (responseCode) {
							case 200:
								onSuccess(data, messages);
								break;
							default:
								onFailure(messages);
								break;
						}
					}
					break;

				default:
					break;
			}
		})
		.catch(error => {
			onError(error);
		});
};
const postApi = (uri, payload, onResponse, onSuccess, onFailure, onError) => {
	axiosInstance
		.post(uri, payload)
		.then(response => {
			switch (response.status) {
				case 200:
					if (response.data.responseCode) {
						const responseCode = response.data.responseCode;
						let data = onResponse(response.data.payload);
						const messages = response.data.messages;
						switch (responseCode) {
							case 200:
								onSuccess(data, messages);
								break;
							default:
								onFailure(messages);
								break;
						}
					}
					break;

				default:
					break;
			}
		})
		.catch(error => {
			onError(error);
		});
};

export const validateUsersFound = (search, bulkSelections, action) => {
	const result = {
		valid: false,
		errorMessage: '',
	};
	const queryParams = new URLSearchParams(search);
	const found = checkForUsersFound(queryParams, bulkSelections);
	if (found) {
		if (bulkSelections) {
			result.valid = true;
		} else {
			if (checkForEsoFiIdNumber(queryParams)) {
				result.valid = true;
			} else {
				result.valid = false;
				result.errorMessage =
					'Invalid ESO requested from URL query parameters.';
			}
		}
	} else {
		result.valid = false;
		result.errorMessage = `No staff selected to ${action}.`;
	}
	return result;
};

export const accountTypeLookup = key => {
	switch (key) {
		case UAR_CONSTANTS.EMPLOYEE_KEY:
			return UAR_CONSTANTS.EMPLOYEE;
		case UAR_CONSTANTS.NON_EMPLOYEE_KEY:
			return UAR_CONSTANTS.NON_EMPLOYEE;
		case UAR_CONSTANTS.CONTINGENT_WORKER_KEY:
			return UAR_CONSTANTS.CONTINGENT_WORKER;
		default:
			return '';
	}
};
